import React, {RefObject} from 'react';
import {useTranslation} from 'react-i18next';
import AccessibilityOutline from '../../../../assets/icons/AccessibilityOutline';
import {ACCESSIBLE_COLOR} from '../../../../config/config';
import EventDateTime from '../../components/EventDateTime/EventDateTime';
import TicketQr from '../../components/TicketQr/TicketQr';
import TicketSeatTiles from '../../components/TicketSeatTiles/TicketSeatTiles';
import VenueLine from '../../components/VenueLine/VenueLine';
import {TEticketEvent, TEticketSeat} from '../../../../redux/eTicket/eTicket.type';
import * as css from './TicketDetailsBody.css';
import {WHITE} from '../../../../globalVariables/GlobalVariables';

interface TicketDetailsBodyProps {
    event: TEticketEvent;
    ticket: {title: string; barcode: string; qid: number, color: string; seat?: TEticketSeat; canceled?: boolean};
    index: number;
    total: number;
    cardQrRef: RefObject<HTMLDivElement>;
    isScanning: boolean;
    reduceMotion: boolean | null;
    onQrZoom: () => void;
}

function TicketDetailsBody({
    event,
    ticket,
    index,
    total,
    cardQrRef,
    isScanning,
    reduceMotion,
    onQrZoom,
}: TicketDetailsBodyProps) {
    const {t} = useTranslation('eTicket');
    const isAccessible = ticket.color === ACCESSIBLE_COLOR;

    return (
        <css.body>
            <css.title>{event.title}</css.title>
            {ticket.title && (
                <css.ticketName $accessible={isAccessible} data-cy="ticket-name">
                    {isAccessible && (
                        <css.a11yIcon aria-hidden>
                            <AccessibilityOutline color={WHITE} />
                        </css.a11yIcon>
                    )}
                    <css.ticketNameText>{ticket.title}</css.ticketNameText>
                </css.ticketName>
            )}
            <EventDateTime event={event} />
            <TicketQr
                barcode={ticket.barcode}
                qrWrapRef={cardQrRef}
                isScanning={isScanning}
                reduceMotion={reduceMotion}
                canceled={ticket.canceled}
                onZoom={onQrZoom}
            />
            <css.ticketNo data-cy="ticket-counter">
                {t('ticketCounter', {current: index + 1, total})}
                {' • '} {ticket.qid}
            </css.ticketNo>
            {ticket.seat && <VenueLine name={event.location} />}
            <TicketSeatTiles seat={ticket.seat} seatMap={event.seatMap} />
        </css.body>
    );
}

export default TicketDetailsBody;
